import { defineStore } from 'pinia'
import axios from 'axios'

export const useModalStore = defineStore({
    id: 'modal',
    state: () => ({
        imageConfirmationModal: {
            show: false,
            itemForDelete: null,
            itemIdForDelete: null
        },
        entityModal: {
            show: false,
            entityType: null,
            entityId: null
        },
        addParcelModal: {
            show: false,
            mode: 'create',
            initialData: null,
            entityId: null
        },
        addPassengerModal: {
            show: false,
            mode: 'create',
            initialData: null,
            entityId: null
        },
        activeRoutePointModal: {
            show: false,
            pointId: null,
            lastCompleted: false,
            firstUncompleted: false
        },
        commentModal: {
            show: false,
            text: null,
            // view | create | edit
            mode: 'view',
            commentId: null,
            entityId: null,
            entityType: null,
            can_edit: false,
            onCreated: null,
            onEdited: null,
            onDeleted: null
        },
        updateAppModal: {
            show: false,
            downloadUrl: ''
        },
        changePasswordModal: {
            show: false
        }
    }),
    actions: {
        async checkAppVersion() {
            const versionUrl = import.meta.env.VITE_DRIVER_APP_VERSION_URL
            const currentVersion = import.meta.env.VITE_APP_VERSION

            if (!versionUrl) return

            try {
                const response = await axios.get(versionUrl)
                const latestVersion = response.data?.version

                if (latestVersion && latestVersion !== currentVersion) {
                    this.updateAppModal.downloadUrl = versionUrl.replace('version.php', 'apk.php')
                    this.updateAppModal.show = true
                }
            } catch (error) {
                console.error('Error checking app version:', error)
            }
        }
    }
})
